/** OneIDM roles, provisioned by DevOps and surfaced as Entra claims. */
export const ROLES = {
  CAMPAIGNS: 'jenny_campaign',
} as const;

export type Role = (typeof ROLES)[keyof typeof ROLES];

function decodeJwtPayload(token: string): Record<string, unknown> {
  const segment = token.split('.')[1];
  if (!segment) throw new Error('Malformed JWT');
  const binary = atob(segment.replace(/-/g, '+').replace(/_/g, '/'));
  const json = new TextDecoder().decode(Uint8Array.from(binary, (c) => c.charCodeAt(0)));
  return JSON.parse(json) as Record<string, unknown>;
}

/**
 * Role names carried by an access token. A OneIDM role reaches the token either
 * as an Entra app role (`roles`) or as a synced group emitted by name
 * (`groups`, sAMAccountName) depending on the app registration, so both count.
 */
export function rolesFromToken(token: string): string[] {
  const payload = decodeJwtPayload(token);
  return ['roles', 'groups'].flatMap((claim) => {
    const value = payload[claim];
    return Array.isArray(value) ? value.filter((v): v is string => typeof v === 'string') : [];
  });
}
